export default __webpack_public_path__ + "static/media/2_long.74a7c5c9.svg";